export const API_PATH_ApiWorkzonesForOfflineUseGet = '/services/devices-mgtm/apiWorkzonesForOfflineUseGet';
